import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "filters" }
const _hoisted_2 = { class: "grid grid-cols-2 md:grid-cols-2 gap-2 w-full" }

import { Select as ASelect } from 'ant-design-vue';
import {PrisonerFilters} from "@/@types/types";
import { ref, watch } from 'vue';
import { affiliationPickerOptions } from '@/composables/affiliationPicker';


export default /*#__PURE__*/_defineComponent({
  __name: 'FiltersComponent',
  props: {
    filters: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// Seeded from the parent rather than starting empty, so a filter the parent
// has already set -- a /database/era/1980s deep link -- shows as a selected
// tag in the dropdown instead of the results being filtered by something the
// UI does not admit to. The parent remounts this component on Clear Filters
// (via :key), at which point modelValue is {} and this seeds empty again.
const selectedFilters = ref<Record<string, string[]>>({ ...(props.modelValue ?? {}) });
const searchQueries = ref<Record<string, string>>({});

const emit = __emit;


watch(selectedFilters, (newVal, oldVal) => {
  emit('update:modelValue', newVal);
}, { deep: true });

// Convert array to Antd select options
const formatOptions = (array: string[], key: string) => (key === 'affiliation'
    ? affiliationPickerOptions(array, searchQueries.value[key])
    : array.filter(item => item.toLowerCase().includes((searchQueries.value[key] ?? '').toLowerCase())))
    .filter(item => item) // Remove falsy values like empty strings
    .map(item => ({ label: item, value: item }));

const updateSelectedFilters = (key: string, selectedOptions: string[]) => {
  console.log('Filters updated')
  selectedFilters.value[key] = selectedOptions;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (options, key) => {
        return (_openBlock(), _createElementBlock("div", { key: key }, [
          _createVNode(_unref(ASelect), {
            class: "w-full",
            mode: "multiple",
            value: selectedFilters.value[key] ?? [],
            options: formatOptions(options, key),
            "filter-option": false,
            onSearch: ($event: any) => (searchQueries.value[key] = $event),
            onBlur: ($event: any) => (searchQueries.value[key] = ''),
            placeholder: key,
            onChange: ($event: any) => (updateSelectedFilters(key, $event))
          }, null, 8, ["value", "options", "onSearch", "onBlur", "placeholder", "onChange"])
        ]))
      }), 128))
    ])
  ]))
}
}

})